import React from 'react'
import { useParams } from 'react-router-dom'
import { useQuery } from 'react-query'
import { useTranslation } from 'react-i18next'

import { showCountry } from '../../../../MyApi/sb/countries'

import PageHeader from '../../../../Components/UI/PageHeader'
import CountryDetalis from '../../../../Components/sb/countries/countriesShow/currencyDetalis'
import LoadingSpinner from '../../../../Components/UI/spinner'




const CountriesShow = () => {
    const {id} =useParams()
    const {i18n}=useTranslation()
    const lang=i18n.language
    const {data , isLoading}= useQuery(["showCountries",id,lang], ()=>showCountry(id,lang))
   const showCountries = data?.data ||{}  

    if(isLoading){
        return <LoadingSpinner/>
    }
    if(!data){
        return<div>no data available</div>
    }
  return (
    <div>
        <PageHeader title="Country Detalis" showBack={true} />
        <CountryDetalis showCountries={showCountries}/>
    </div>
  )
}

export default CountriesShow